import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { NavigationItem as _NavigationItem, NavigationItemChild as _NavigationItemChild } from './header.nav';
import { Subject, takeUntil, timer } from 'rxjs';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { HeaderService } from './header.service';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';
import { KeycloakInitializerService } from 'src/app/services/keycloakInitializer.service';

interface NavigationItem extends _NavigationItem {
    hovered?: boolean;
}

export interface NavigationItemChild {
    hovered?: boolean;
}

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    animations: [
        trigger('fadeInOut', [
            state('void', style({ opacity: 0, transform: 'translateY(-1rem)' })),
            transition('void <=> *', animate(150)),
        ]),
    ],
})
export class HeaderComponent implements OnInit {
    protected mobileOpened: boolean = false;

    protected staticNavigationItems: NavigationItem[] = [
        {
            id: "home",
            title: $localize`:@@header.navigation_home:Home`,
            routerLink: "/"
        },
        /*{
          id: "support",
          title: "Support",
          // notSensitive: true,
          children: [
            {
              id: "supportNewRequest",
              title: "New request",
              //description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
              routerLink: "my-account/ticket/new-ticket",
              icon: {
                pack: "font-awesome-solid",
                icon: "pen"
              }
            },
            {
              id: "supportMyReques",
              title: "My requests",
              //description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
              routerLink: "my-account/ticket",
              icon: {
                pack: "font-awesome-solid",
                icon: "list"
              }
            },
          ]
        },*/
        {
            id: "community",
            title: $localize`:@@header.navigation_community:Community`,
            children: [
                {
                    id: "communityDiscord",
                    title: $localize`:@@header.navigation_discord:Discord`,
                    //  description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
                    onClick: () => window.open(environment.discord_url, "_blank"),
                    icon: {
                        pack: "font-awesome-brands",
                        icon: "discord"
                    }
                },
                {
                    id: "communityTwitter",
                    title: $localize`:@@header.navigation_X:X`,
                    //description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
                    onClick: () => window.open(environment.twitter_url, "_blank"),
                    icon: {
                        pack: "font-awesome-brands",
                        icon: "x-twitter"
                    }
                },
                {
                    id: "communityFacebook",
                    title: $localize`:@@header.navigation_facebook:Facebook`,
                    // description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
                    onClick: () => window.open(environment.facebook_url, "_blank"),
                    icon: {
                        pack: "font-awesome-brands",
                        icon: "square-facebook"
                    }
                },
                {
                    id: "communityInstagram",
                    title: $localize`:@@header.navigation_instagram:Instagram`,
                    // description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
                    onClick: () => window.open(environment.instagram_url, "_blank"),
                    icon: {
                        pack: "font-awesome-brands",
                        icon: "instagram"
                    }
                }
            ]
        }
    ];

    protected staticMyAccountNavigationItems: NavigationItem[] = [
        {
            id: "myAccount",
            title: "My Account",
            mobileOnly: true,
            //notSensitive: true,
            children: [
                {
                    id: "myAccountProfile",
                    title: $localize`:@@header.navigation_profile:Profile`,
                    routerLink: "my-account/profile",
                    icon: {
                        pack: "font-awesome-solid",
                        icon: "id-card"
                    }
                },
                {
                    id: "myAccountRental",
                    title: $localize`:@@header.navigation_rentals:Rentals`,
                    routerLink: "my-account",
                    icon: {
                        pack: "font-awesome-solid",
                        icon: "list"
                    }
                },
                {
                    id: "myAccountTicket",
                    title: $localize`:@@header.navigation_tickets:Tickets`,
                    routerLink: "my-account/ticket",
                    icon: {
                        pack: "font-awesome-solid",
                        icon: "id-card"
                    }
                },
                {
                    id: "myAccountSubscription",
                    title: $localize`:@@header.navigation_subscriptions:Subscriptions`,
                    routerLink: "my-account/subscription",
                    icon: {
                        pack: "font-awesome-solid",
                        icon: "credit-card"
                    }
                },
                {
                    id: "myAccountInvoice",
                    title: $localize`:@@header.order_invoices:Orders / Invoices`,
                    routerLink: "my-account/orders",
                    icon: {
                        pack: "font-awesome-solid",
                        icon: "file-invoice"
                    }
                }
            ]
        },
    ]

    private destroy$: Subject<void> = new Subject();
    private openedNavigationItem: NavigationItem = null;
    private openedNavigationContainer: any;

    get navigationItems() {
        return this.headerService.getNavigationItems;
    }

    constructor(private headerService: HeaderService, protected authService: AuthService, private keycloakInitializer: KeycloakInitializerService) {
        this.staticNavigationItems.map((item) => headerService.addNavigationItem(item));
    }

    ngOnInit() {
        if (this.keycloakInitializer.isInitialized) {
            this.staticMyAccountNavigationItems.map((item) => this.headerService.addNavigationItem(item));
        } else {
            this.keycloakInitializer.initialized
                .pipe(takeUntil(this.destroy$))
                .subscribe(() => {
                    this.staticMyAccountNavigationItems.map((item) => this.headerService.addNavigationItem(item));
                })
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    @HostListener('document:click', ['$event'])
    documentClick(event) {
        if (!this.openedNavigationContainer?.contains(event.target) && this.openedNavigationItem) {
            this.openedNavigationItem.hovered = false;
            this.openedNavigationItem = null;
        }
    }

    protected onNavigationItemEnter(navigationItem: NavigationItem, container: ElementRef): void {
        this.openedNavigationContainer = container;
        this.removeChildrenOvering();

        if (this.openedNavigationItem) {
            this.openedNavigationItem.hovered = false;
        }

        if (navigationItem == this.openedNavigationItem) {
            this.openedNavigationItem = null;
        } else {
            navigationItem.hovered = true;
            this.openedNavigationItem = navigationItem;
        }
    }

    protected onNavigationItemClicked(navigationItem?: NavigationItem): void {
        if (navigationItem) {
            navigationItem.hovered = false;
        }

        this.openedNavigationItem.hovered = false
        this.openedNavigationItem = null;
    }

    private removeChildrenOvering(): void {
        for (let navigationItem of this.navigationItems) {
            if (!navigationItem?.children?.length) {
                continue;
            }

            (navigationItem.children as NavigationItemChild[]).map((navigationItemChild) => navigationItemChild.hovered = false);
        }
    }
}
